<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="订单编号：" prop="sn">
                <el-input v-model="model.sn"></el-input>
            </el-form-item>
            <el-form-item label="会员ID：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="订单状态：" prop="status">
                <el-input v-model="model.status"></el-input>
            </el-form-item>
            <el-form-item label="创建时间：" prop="createtime">
                <el-input v-model="model.createtime"></el-input>
            </el-form-item>
            <el-form-item label="支付时间：" prop="paytime">
                <el-input v-model="model.paytime"></el-input>
            </el-form-item>
            <el-form-item label="审核时间：" prop="confirmtime">
                <el-input v-model="model.confirmtime"></el-input>
            </el-form-item>
            <el-form-item label="发货时间：" prop="sendtime">
                <el-input v-model="model.sendtime"></el-input>
            </el-form-item>
            <el-form-item label="完成时间：" prop="completetime">
                <el-input v-model="model.completetime"></el-input>
            </el-form-item>
            <el-form-item label="所在区域：" prop="regions">
                <el-input v-model="model.regions"></el-input>
            </el-form-item>
            <el-form-item label="收货地址：" prop="address">
                <el-input v-model="model.address"></el-input>
            </el-form-item>
            <el-form-item label="收货人：" prop="receiver">
                <el-input v-model="model.receiver"></el-input>
            </el-form-item>
            <el-form-item label="收货人电话：" prop="receiver_phone">
                <el-input v-model="model.receiver_phone"></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" prop="goods_name">
                <el-input v-model="model.goods_name"></el-input>
            </el-form-item>
            <el-form-item label="商品图片：" prop="main_pic">
                <el-input v-model="model.main_pic"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="商品数量：" prop="goods_count">
                <el-input v-model="model.goods_count"></el-input>
            </el-form-item>
            <el-form-item label="会员优惠券ID：" prop="member_coupon_id">
                <el-input v-model="model.member_coupon_id"></el-input>
            </el-form-item>
            <el-form-item label="配送方式：" prop="post_type">
                <el-input v-model="model.post_type"></el-input>
            </el-form-item>
            <el-form-item label="订单总额：" prop="order_price">
                <el-input v-model="model.order_price"></el-input>
            </el-form-item>
            <el-form-item label="商品金额：" prop="goods_price">
                <el-input v-model="model.goods_price"></el-input>
            </el-form-item>
            <el-form-item label="配送费：" prop="post_fee">
                <el-input v-model="model.post_fee"></el-input>
            </el-form-item>
            <el-form-item label="优惠券金额：" prop="coupon_price">
                <el-input v-model="model.coupon_price"></el-input>
            </el-form-item>
            <el-form-item label="支付方式：" prop="pay_type">
                <el-input v-model="model.pay_type"></el-input>
            </el-form-item>
            <el-form-item label="支付金额：" prop="pay_price">
                <el-input v-model="model.pay_price"></el-input>
            </el-form-item>
            <el-form-item label="余额支付金额：" prop="pay_balance">
                <el-input v-model="model.pay_balance"></el-input>
            </el-form-item>
            <el-form-item label="在线支付金额：" prop="pay_online">
                <el-input v-model="model.pay_online"></el-input>
            </el-form-item>
            <el-form-item label="微信支付订单号：" prop="transaction_id">
                <el-input v-model="model.transaction_id"></el-input>
            </el-form-item>
            <el-form-item label="后台备注：" prop="remark_admin">
                <el-input v-model="model.remark_admin"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'orderEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                sn: '',
                member_id: '',
                status: '',
                createtime: '',
                paytime: '',
                confirmtime: '',
                sendtime: '',
                completetime: '',
                regions: '',
                address: '',
                receiver: '',
                receiver_phone: '',
                goods_name: '',
                main_pic: '',
                remark: '',
                goods_count: '',
                member_coupon_id: '',
                post_type: '',
                order_price: '',
                goods_price: '',
                post_fee: '',
                coupon_price: '',
                pay_type: '',
                pay_price: '',
                pay_balance: '',
                pay_online: '',
                transaction_id: '',
                remark_admin: '',
            },
            getObj:{
                url:'/api/admin/order/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/order/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>